export enum Rarity {
  Special = 0,
  Common,
  Rare,
  Epic,
  Legendary,
  Ancient,
}